import ConfirmationDlg from "../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import WorkOrderCategory from "./WorkOrderCategory";
function ModalAISummary({ openModal, setOpenModal, data }) {
  const handleClose = () => {
    setOpenModal(false);
  };
  return (
    <ConfirmationDlg
      open={openModal}
      size={"lg"}
      hideCancelBtn={true}
      btnCancelText="Cancel"
      btnSubmitText={"OK"}
      onSubmit={handleClose}
      onClose={handleClose}
    >
      <div class="row">
        <div class="col-sm-6 mb-3">
          <Card>
            <CardHeader>
              <h4>Top 5 Faults</h4>
            </CardHeader>
            <CardBody>
              <table className="table table-sm table-bordered table-striped">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Fault</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {data.topFault.map((fault, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{fault.fault}</td>
                      <td>{fault.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
        <div class="col-sm-6 mb-3">
          <Card>
            <CardHeader>
              <h4>Top 5 Asset With Work Order</h4>
            </CardHeader>
            <CardBody>
              <table className="table table-sm table-bordered table-striped">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Asset</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {data.topAsset.map((fault, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{fault.asset_name}</td>
                      <td>{fault.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
        <div class="col-sm-6">
          <Card>
            <CardHeader>
              <h4>Top 5 Work Order by Longest Completion</h4>
            </CardHeader>
            <CardBody>
              <table className="table table-sm table-bordered table-striped">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Work Order</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {data.topDuration.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.title}</td>
                      <td>{item.formattedDuration}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
        <div class="col-sm-6">
          <Card>
            <CardHeader>
              <h4>Top 5 Work Order by Category</h4>
            </CardHeader>
            <CardBody>
              <table className="table table-sm table-bordered table-striped">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Category</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {data.topCategory.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.category}</td>
                      <td>{item.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalAISummary;
